import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-insight',
	path: '/jira/servicedesk/insight',
	exact: true,
};
